"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AccordionGalleryContext: function() {
        return AccordionGalleryContext;
    },
    AccordionGallery: function() {
        return AccordionGallery;
    }
});
var _react = _interop_require_wildcard(require("react"));
var _components = require("@cmpsr/components");
var _components1 = require("./components/index");
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var AccordionGalleryContext = (0, _react.createContext)({
    images: null
});
var AccordionGallery = function(_param) {
    var children = _param.children, _param_defaultImage = _param.defaultImage, defaultImage = _param_defaultImage === void 0 ? 0 : _param_defaultImage, rest = _object_without_properties(_param, [
        "children",
        "defaultImage"
    ]);
    var _images_current, _images_current1;
    var isMobile = (0, _components.useBreakpointValue)({
        base: true,
        lg: false
    });
    var _useState = _sliced_to_array((0, _react.useState)(null), 2), activeItem = _useState[0], setActiveItem = _useState[1];
    var images = (0, _react.useRef)({});
    (0, _react.useEffect)(function() {
        if (typeof defaultImage !== "number") {
            images.current["default"] = defaultImage;
            setActiveItem("default");
        } else {
            setActiveItem(defaultImage);
        }
    }, []);
    var textPairing = null;
    var accordion = null;
    var legend = null;
    var action = null;
    var handleAccordionChange = function(index) {
        var _accordion_props_onChange, _accordion_props;
        var selectedImageIndex = index !== -1 ? index : typeof defaultImage === "number" ? defaultImage : "default";
        (_accordion_props = accordion.props) === null || _accordion_props === void 0 ? void 0 : (_accordion_props_onChange = _accordion_props.onChange) === null || _accordion_props_onChange === void 0 ? void 0 : _accordion_props_onChange.call(_accordion_props, index);
        setActiveItem(selectedImageIndex);
    };
    _react.Children.map(children, function(child) {
        if ((0, _react.isValidElement)(child)) {
            switch(child.type){
                case _components.Text:
                    legend = child;
                    break;
                case _components.TextPairing:
                    textPairing = child;
                    break;
                case AccordionGalleryAccordion:
                    accordion = child;
                    break;
                case _components.Link:
                    action = child;
                    break;
            }
        }
    });
    return _react.default.createElement(AccordionGalleryContext.Provider, {
        value: {
            images: images
        }
    }, _react.default.createElement(_components.Flex, _object_spread({
        gap: {
            md: "2rem",
            lg: "3rem",
            xxl: "5.75rem"
        },
        alignItems: {
            md: "center"
        },
        justifyContent: "center"
    }, rest), !isMobile && ((_images_current = images.current) === null || _images_current === void 0 ? void 0 : _images_current[activeItem]) ? images.current[activeItem] : null, _react.default.createElement(_components.Flex, {
        flexDirection: "column",
        gap: {
            base: "2rem",
            md: "1.5rem",
            lg: "3rem"
        }
    }, legend, textPairing, isMobile && ((_images_current1 = images.current) === null || _images_current1 === void 0 ? void 0 : _images_current1[activeItem]) ? images.current[activeItem] : null, accordion && (0, _react.cloneElement)(accordion, {
        onChange: handleAccordionChange
    }), action)));
};
var AccordionGalleryAccordion = Object.assign(_components1.AccordionGalleryAccordion, {
    Image: _components1.AccordionGalleryImage,
    Item: _components1.AccordionGalleryItem,
    Button: _components.Accordion.Button,
    Panel: _components.Accordion.Panel,
    Icon: _components.Accordion.Icon
});
AccordionGallery.Title = _components.TextPairing;
AccordionGallery.Accordion = AccordionGalleryAccordion;
AccordionGallery.Overline = _components.Text;
AccordionGallery.Action = _components.Link;
